import { writable } from "svelte/store"
import type { Config } from "../services/models"

function saveConfig() {
  let localConfig = sessionStorage.getItem("config")
  let config: Config = {} as Config;
  if (localConfig) config = JSON.parse(localConfig)

  const { subscribe, set } = writable<Config>(config)

  return {
    subscribe,
    set: (config: Config) => {
      sessionStorage.setItem("config", JSON.stringify(config))
      set(config)
    },
  }
}

export default saveConfig()
